import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import IconLoadingBlue from '../../assets/images/ic-loading-blue.svg';

const useStyles = makeStyles(() => {
  return {
    iconLoading: {
      height: '44px',
      width: '44px',
    },
    videoReportLoading: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
      marginBottom: '10px',
      textAlign: 'center',
    },
  };
});

export default () => {
  const classes = useStyles();

  return (
    <div style={{ padding: '140px 0px 110px' }}>
      <Typography className={classes.videoReportLoading}>Loading Details...</Typography>
      <Grid container justify="center">
        <Grid item>
          <img src={IconLoadingBlue} className={`${classes.iconLoading} rotate`} alt="Mediphany loading" />
        </Grid>
      </Grid>
    </div>
  );
};
